module.exports = __webpack_public_path__ + "static/media/purchase-succeeded.5e204502.png";